/** @format */

import React, { useEffect, useState } from "react";
import moment from "moment";
import { Box, Button, Text } from "@chakra-ui/react";
import { useRecomendacao } from "../../../context/useRecomendacao";
import { FiltrosItem } from "../../../components/FiltrosItem";
import { Header } from "../../../components/Header";
import { useHistory, useLocation } from "react-router-dom";
import queryString from "query-string";
import { formatRecomendacao } from "../../../utils";
import { usePersonalizacao } from "../../../context/usePersonalizacao";

export function Filtros() {
  const {
    filtros: tipos,
    selectedFiltros,
    addSelectedFilters,
    recomendacao,
  } = useRecomendacao();
  const history = useHistory();
  const location = useLocation();
  const {
    personalizacao: { guiaofertas, filtros },
  } = usePersonalizacao();

  const [temporaryFiltros, setTemporaryFiltros] = useState([]);
  const { destaques, ofertas, descontoExclusivo, dinheiroDeVolta } =
    formatRecomendacao(recomendacao, guiaofertas?.hasDestaques);

  useEffect(() => {
    setTemporaryFiltros([...selectedFiltros]);
  }, [selectedFiltros]);

  const handleSubmit = async () => {
    await addSelectedFilters({ filtros: temporaryFiltros });
    history.goBack();
  };

  const addFilter = ({ tipo }) => {
    const newSelectedFiltros = temporaryFiltros;
    const check = newSelectedFiltros.every((data) => {
      return tipo.id !== data.id;
    });
    if (check) {
      selectedFiltros.filter((data) => {
        return tipo.id === data.id;
      });
      temporaryFiltros.push(tipo);
      setTemporaryFiltros([...newSelectedFiltros]);
    } else {
      temporaryFiltros.forEach((item, index) => {
        if (item.id === tipo.id) {
          temporaryFiltros.splice(index, 1);
        }
      });
      setTemporaryFiltros([...newSelectedFiltros]);
    }
  };

  const verificaFiltroAtivo = (data) => {
    if (temporaryFiltros.filter((filtros) => filtros.id === data.id)[0]) {
      return true;
    } else {
      return false;
    }
  };

  const verificaTipoASerExibido = () => {
    let tiposSerExibido = tipos;

    if (
      ofertas.length === 0 &&
      destaques.filter((data) => data.idtiporecomendacao === "2").length === 0
    ) {
      const filter = tiposSerExibido.filter(
        (data) => data.idtiporecomendacao !== "2",
      );
      tiposSerExibido = filter;
    }
    if (
      descontoExclusivo.length === 0 &&
      destaques.filter((data) => data.idtiporecomendacao === "1").length === 0
    ) {
      const filter = tiposSerExibido.filter(
        (data) => data.idtiporecomendacao !== "1",
      );
      tiposSerExibido = filter;
    }
    if (
      dinheiroDeVolta.length === 0 &&
      destaques.filter((data) => data.idtiporecomendacao === "3").length === 0
    ) {
      const filter = tiposSerExibido.filter(
        (data) => data.idtiporecomendacao !== "3",
      );
      tiposSerExibido = filter;
    }
    if (
      recomendacao.filter((data) => data.id_classificacao_topete === "1")
        .length === 0
    ) {
      const filter = tiposSerExibido.filter(
        (data) => data.id_classificacao_topete !== "1",
      );
      tiposSerExibido = filter;
    }
    if (
      recomendacao.filter((data) => data.id_classificacao_topete === "2")
        .length === 0 || filtros?.hideParaVoce === true
    ) {
      const filter = tiposSerExibido.filter(
        (data) => data.id_classificacao_topete !== "2",
      );
      tiposSerExibido = filter;
    }
    if (recomendacao.filter((data) => data.clube).length === 0) {
      const filter = tiposSerExibido.filter((data) => data.clube !== true);
      tiposSerExibido = filter;
    }
    if (queryString.parse(location.search).screen === "vermais") {
      if (queryString.parse(location.search).isdestaque === "true") {
        const filter = tiposSerExibido.filter(
          (data) => data.id_classificacao_topete !== "1",
        );

        tiposSerExibido = filter;
      } else {
        const filter = tiposSerExibido.filter(
          (data) => !data.idtiporecomendacao,
        );
        tiposSerExibido = filter;
      }
      if (
        queryString.parse(location.search).isdestaque === "false" &&
        queryString.parse(location.search).hasdestaque === "true"
      ) {
        const filter = tiposSerExibido.filter(
          (data) => data.id_classificacao_topete !== "1",
        );
        tiposSerExibido = filter;
      }
    }

    const expiraEmSeteValida = recomendacao.filter((data) => {
      let dataAtual = moment(
        new Date().toLocaleDateString("pt-BR", { timeZone: "UTC" }),
        "DD/MM/YYYY",
      );
      let validadeate = moment(
        new Date(data.validadeate).toLocaleDateString("pt-BR", {
          timeZone: "UTC",
        }),
        "DD/MM/YYYY",
      );

      let diff = moment(validadeate, "DD/MM/YYYY").diff(
        dataAtual,
        "DD/MM/YYYY",
      );
      let diffInDays = moment.duration(diff).asDays();

      if (diffInDays <= 7) {
        return data;
      } else {
        return null;
      }
    });

    if (expiraEmSeteValida.length === 0) {
      const filter = tiposSerExibido.filter((data) => !data.expira);
      tiposSerExibido = filter;
    }

    return tiposSerExibido;
  };

  return (
    <>
      <Header />
      <Box
        maxWidth="900px"
        margin="0 auto"
        padding="1rem"
        height={"calc(100vh - 4rem)"}
        background="white"
        display="flex"
        flexDir="column"
        justifyContent="space-between">
        <Box display="flex" flexDir="column">
          <Text
            fontSize="1rem"
            fontWeight="bold"
            color="#70747D"
            marginLeft="0.5rem">
            Tipo
          </Text>
          <Box
            marginTop="0.5rem"
            flexWrap="wrap"
            display="flex"
            alignItems="center"
            justifyContent="flex-start"
            flexDir="row">
            {verificaTipoASerExibido().map((data, index) => {
              return (
                <FiltrosItem
                  key={index}
                  label={data.label}
                  onClick={() => addFilter({ tipo: data })}
                  isSelected={verificaFiltroAtivo(data)}
                />
              );
            })}
          </Box>
        </Box>
        <Button
          background="#186DAF"
          transition="filter 0.2s"
          height="3rem"
          borderRadius="full"
          _hover={[{ filter: "brightness(0.9)" }]}
          onClick={() => handleSubmit()}>
          <Text color="white" fontSize="1rem">
            Ver resultados
          </Text>
        </Button>
      </Box>
    </>
  );
}
